import { new__cn as cn } from '@/component/UI/util';

import { VBaseButton, useButton } from '../VBaseButton';
import { ProgressActivity } from '../asset';
import { ICON_BUTTON_SIZE, ICON_BUTTON_VARIANT } from './constant';
import twStyle from './style';
import type { VIconButtonProps } from './type';

export const VIconButton = (
  props: VIconButtonProps & React.ComponentPropsWithRef<'button'>,
) => {
  const {
    ref,

    Icon,
    className,
    disabled,
    loading,
    outlined = false,
    size = ICON_BUTTON_SIZE.MD,
    variant = ICON_BUTTON_VARIANT.PRIMARY,

    onClick,
    ...buttonProps
  } = props;
  const { isLoading, handleClick } = useButton({ disabled, loading, onClick });
  const style = twStyle({ outlined, size, variant });

  return (
    <VBaseButton
      aria-label="v-icon-button"
      className={cn(style.iconButton, className)}
      disabled={disabled}
      loading={isLoading}
      outlined={outlined}
      ref={ref}
      onClick={handleClick}
      {...buttonProps}
    >
      {isLoading ? (
        <ProgressActivity
          aria-label="loading-spinner"
          className="animate-spin"
          role="status"
        />
      ) : (
        <Icon />
      )}
    </VBaseButton>
  );
};

VIconButton.displayName = 'VIconButton';
